
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M128 64.2c.9 33.6-28.4 65.2-66.5 63.8C27.7 126.7 0 98.1 0 64 0 30.3 27.6-.6 65.2 0c36.1.6 63.6 30.8 62.8 64.2zm-10.1-4.1c-.1-7.9-2.9-19.1-9.3-29.3C98.3 14.6 83.8 5.2 64.5 4.7c-14.3-.4-26.6 5.4-36.6 15.5C7.5 40.9 4.5 74.7 20.6 98.8c14.3 21.3 38.9 29.8 61.4 21 21.3-8.2 35.8-30.8 35.9-59.7z"}}),_c('path',{attrs:{"opacity":".7","d":"M83.9 82.2c-3.2 3.5-6.1 6.6-9.5 10.3-4-4.2-8-8.3-11.8-12.4-3.7-4-3.6-4 .3-7.9 1.8-1.8 3.3-3.9 4.5-5.4 6.1 5.7 11.4 10.7 16.5 15.4zM81.1 62.5c-5.6-5.9-10.2-10.7-14.6-15.7-.5-.5-.6-2.2-.1-2.7 2.5-3 5.2-5.7 8.4-9.2 5.3 5.5 10 10.3 14.6 15.2.5.5.5 2.2 0 2.8-2.5 3.1-5 5.8-8.3 9.6zM71.9 58.4c-5.1 5-10.2 10.1-14.9 14.8-3.8-3.1-7.3-6-10.6-8.8C52 58.6 57 53.5 62.2 48.1c3.2 3.4 6.2 6.6 9.7 10.3zM62.3 85.3c3.3 3.5 6.2 6.6 9.7 10.2-4.6 4.5-9.4 9.2-14.4 13.8-.5.5-2 .7-2.3.3-2.1-2.2-4.6-4.4-5.6-7.1-.6-1.6.6-4.6 1.9-6.2 3.1-3.7 6.9-7.1 10.7-11zM78.6 69.7c4.6-4.7 9.6-9.8 15-15.3 2.2 2.4 4.9 4.5 6.4 7.2 1.2 2.3.6 5.2-1.6 7.3-3.6 3.5-7.1 7.1-10.8 10.8-3.1-3.4-6.1-6.8-9-10zM37.2 35.2C43 41 48 46 53.2 51.3c-3.3 3.2-6.5 6.2-9.4 9-3.9-3.7-8.3-7.4-12.2-11.6-2-2.1-1.6-5 .2-7.4 1.7-1.9 3.4-3.8 5.4-6.1zM61.8 42.3c-3.3-3.3-6.9-6.8-10.4-10.4-3.1-3.3-3.1-6.9 0-10.1 1.5-1.5 3-2.9 4.7-4.5L71.8 33c-3.2 3-6.4 6-10 9.3zM52.9 76.9c-5 4.8-10.1 9.7-15.6 14.9-1.5-1.4-3.5-3-5.1-4.9-2.5-3-2.4-6.2.4-9 3.6-3.6 7.4-7.1 11.2-10.7 2.7 2.9 5.7 6.2 9.1 9.7z"}})])
          )
        }
      }
    